import React from "react";

import Addposter from "../../assets/images/Home/Choosesec/addposter.png";
import { Col, Row } from "react-bootstrap";
const Choosekansensus = () => {
  return (
    <>
      <div className="choose-kansensus-component container">
        <Row>
          <Col className="choose-kansensus-details mt-5" xs={12} md={12} lg={6}>
            <div className="content mt-1">
              <h5>Why Choose Us?</h5>
              <h1 className="mt-3">
                User-Friendly <span>Interface</span>
              </h1>
              <div className="para mt-3">
                <p>Designed for seamless navigation and interaction.</p>
                <br />
              </div>
            </div>
            <div className="content mt-1">
              <h1>
                Smart <span>Networking Tools</span>
              </h1>
              <div className="para mt-3">
                <p>Manage contacts and build meaningful connections.</p>
                <br />
              </div>
            </div>
            <div className="content mt-1">
              <h1>
                Multi-Platform <span>Access </span>
              </h1>
              <div className="para mt-3">
                <p>Available on iOS, Android, and Web.</p>
                <br />
              </div>
            </div>
          </Col>
          <Col
            className="choose-kansensus-image mt-5"
            xs={12}
            md={12}
            lg={{ span: 4, offset: 2 }}
          >
            <img src={Addposter} alt="" />
          </Col>
        </Row>
      </div>
    </>
  );
};
export { Choosekansensus };
